import { create } from 'zustand'

interface RemindersState {
  sent: Set<string>
  markReminded: (campusId: string) => void
  wasReminded: (campusId: string) => boolean
}

export const useRemindersStore = create<RemindersState>((set, get) => ({
  sent: new Set<string>(),
  markReminded: (campusId) =>
    set((state) => {
      const next = new Set(state.sent)
      next.add(campusId)
      return { sent: next }
    }),
  wasReminded: (campusId) => get().sent.has(campusId),
}))
